import { api } from '@smena/ui';

// type, а не interface: только псевдонимы объектных типов получают неявную index-signature
// и потому присваиваются в Record<string, unknown> - его ждёт data-проп Recharts-обёртки.
export type DayPoint = {
  day: string;
  n: number;
};

export interface Overview {
  accounts: { total: number; client: number; demo: number };
  properties: number;
  guests: number;
  bookings: { total: number; today: number; last7: number; last30: number };
  sessions: { total: number; activeLast7: number };
  messages: { total: number; last30: number };
  escalations: { open: number; last30: number };
  pendingActions: Record<string, number>;
  series: { messages: DayPoint[]; bookings: DayPoint[]; escalations: DayPoint[] };
}

export type LlmDayPoint = {
  day: string;
  calls: number;
  fallbacks: number;
  promptTokens: number;
  completionTokens: number;
  cacheHitTokens: number;
  avgLatencyMs: number;
};

export interface LlmAnalytics {
  totals: {
    calls: number;
    fallbacks: number;
    promptTokens: number;
    completionTokens: number;
    cacheHitTokens: number;
    avgLatencyMs: number;
  };
  byDay: LlmDayPoint[];
  byAccount: Array<{
    accountId: string;
    slug: string;
    name: string;
    calls: number;
    fallbacks: number;
    totalTokens: number;
  }>;
  byModel: Array<{ model: string; calls: number; totalTokens: number }>;
}

export function fetchOverview(days: number): Promise<Overview> {
  return api<Overview>(`/api/admin/analytics/overview?days=${days}`);
}

export function fetchLlmAnalytics(days: number): Promise<LlmAnalytics> {
  return api<LlmAnalytics>(`/api/admin/analytics/llm?days=${days}`);
}
